export default "__VITE_ASSET__71900a88__"